import { ReactComponent as BenefitSVG } from "./benefit.svg";
import { SvgIcon } from '@mui/material';

export default function IconBenefit(props) {
  return <SvgIcon {...props} component={BenefitSVG} viewBox="0 0 25 24" />;
}